import Component from 'flarum/common/Component';
import { discussionViews, formatViews } from '../utils';
/**
 * Estatísticas na lateral da discussão, entre Responder (@100) e o Scrubber
 * (@-100): visualizações (michaelbelgium/flarum-discussion-views), respostas e
 * likes do primeiro post (flarum/likes).
 */
export default class AvocadoDiscussionStats extends Component {
  view() {
    const {
      discussion
    } = this.attrs;
    if (!discussion) return m("div", {
      className: "AvocadoSidebar-stats"
    });
    const replyCount = Number(discussion.replyCount?.()) || 0;
    const viewCount = discussionViews(discussion) ?? 0;
    const firstPost = discussion.firstPost?.();
    const likeCount = Number(firstPost?.attribute?.('likesCount') ?? firstPost?.likesCount?.() ?? 0);
    const rows = [viewCount > 0 && {
      key: 'views',
      icon: 'far fa-eye',
      label: 'Views',
      value: formatViews(viewCount)
    }, true && {
      key: 'replies',
      icon: 'far fa-comment',
      label: 'Replies',
      value: String(replyCount)
    }, likeCount > 0 && {
      key: 'likes',
      icon: 'far fa-thumbs-up',
      label: 'Likes',
      value: String(likeCount)
    }].filter(Boolean);
    return m("div", {
      className: "AvocadoSidebar-stats"
    }, rows.map(({
      key,
      icon,
      label,
      value
    }) => m("div", {
      key: key,
      className: "AvocadoSidebar-statRow"
    }, m("span", {
      className: "AvocadoSidebar-statLabel"
    }, m("i", {
      className: icon,
      "aria-hidden": "true"
    }), label), m("span", {
      className: "AvocadoSidebar-statValue"
    }, value))));
  }
}
flarum.reg.add('ramon-avocado', 'forum/components/AvocadoDiscussionStats', AvocadoDiscussionStats);